var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 20,
    viewBox: "0 0 5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.5,11A2.5,2.5,0,1,0,15,8.5,2.507,2.507,0,0,0,17.5,11Zm0,2.5A2.5,2.5,0,1,0,20,16,2.507,2.507,0,0,0,17.5,13.5Zm0,7.5A2.5,2.5,0,1,0,20,23.5,2.507,2.507,0,0,0,17.5,21Z",
    transform: "translate(-15 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkDotIcon);
export default __webpack_public_path__ + "static/media/dark-dot-icon.3b213bde89c9054792ce844b57b6c2f4.svg";
export { ForwardRef as ReactComponent };